import StepModal from "src/pages/steps/StepTilaus/Modals/StepModal";
import PropTypes from "prop-types";
import { lazy } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
const TuoteSelecor = lazy(() => import("./TuoteSelector"));

export default function TuoteSelecorModal(props) {
  const open = props.open;
  const onClose = props.onClose;

  const handleSaveClick = (tuote) => {
    onClose(tuote);
  };
  const handleCancelClick = () => {
    onClose(null);
  };
  const handleSelectTuote = (tuote) => {
    onClose(tuote);
  };

  return (
    <StepModal
      open={open}
      onCloseKlik={handleCancelClick}
      onCancelKlik={handleCancelClick}
      onSaveKlik={handleSaveClick}
      closeButtonText="VALITSE"
      title="Valitse tuote">
      <LazyLoader>
        <TuoteSelecor
          setTuote={handleSelectTuote}
          laskuttajaAsiakasId={props.laskuttajaAsiakasId}
        />
      </LazyLoader>
    </StepModal>
  );
}

TuoteSelecorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  laskuttajaAsiakasId: PropTypes.number,
};
